module.exports = __webpack_public_path__ + "img/xinyongzhi.01fdb673.png";